/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2024-06-07 10:33:30
 *
 *******************************************************/
// @flow
import React, { Component } from 'react';
import { withI18n } from '@shopify/react-i18n';
import Banner from 'src/components/views/common/banners/pfs-banner-custom';
import waveIcon from 'src/assets/images/common/wave-warning-icon.png';
import { URL } from 'src/constants/links';
import { routes } from 'src/routes';
import history from 'src/routes/history';
import type { ComposedProps, State } from './index.type';
import { Icon } from '@shopify/polaris';
import { LockMinor } from '@shopify/polaris-icons';

class FreemiumBanner extends Component<ComposedProps, State> {
  render() {
    const { i18n, urlText = '' } = this.props;

    return (
      <Banner
        name="freemiumAnalyticBanner"
        title={i18n.translate('AdminHTML.Analytics.AnalyticsV2.freemiumBanner_Title')}
        titleIcon="rocket"
        status="warning"
        hasOutline={true}
        children={
          <div style={{ height: '70px' }}>
            {i18n.translate('AdminHTML.Analytics.AnalyticsV2.freemiumBanner_Content')}
          </div>
        }
        backgroundImage={waveIcon}
        action={{
          custom: (
            <div
              className={`Polaris-Button`}
              onClick={() => history.push(routes.subscription.package())}>
              <Icon source={LockMinor} />
              {i18n.translate(`AdminHTML.Common.Action.upgradeToUnlock`)}
            </div>
          ),
          content: i18n.translate('AdminHTML.Common.Action.upgradeToUnlock'),
          onAction: () => history.push(routes.subscription.package())
        }}
        secondaryAction={{
          content: i18n.translate('AdminHTML.Common.Action.learnMore'),
          onAction: () => this.openLink(urlText)
        }}
      />
    );
  }

  openLink = (id: string) => {
    const newUrl = URL[id];
    window.open(newUrl, '_blank');
  };
}

export default withI18n()(FreemiumBanner);
